<template>
  <div class="video-setting-wrapper">
    <el-dialog class="common-dialog" :visible.sync="visible" center :modal-append-to-body="false" :close-on-click-modal="false" title="视频推荐设置" @close="closeHandler">
      <div class="video-setting-content-wrapper">
        <el-form class="video-setting-content" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="标题设置" prop="shareTitle">
            <el-input v-model="ruleForm.shareTitle" placeholder="请输入20字以内的文本信息"></el-input>
          </el-form-item>
          <el-form-item label="微信摘要设置" prop="description">
            <el-input v-model="ruleForm.description" type="textarea" resize="none" :maxlength="100" placeholder="请输入100字以内的文本信息 例如：该书刊简介与特色等"></el-input>
          </el-form-item>
          <el-form-item label="微信链接封面" prop="thumbnail">
            <div class="video-setting-thumbnail">
              <MediaUpload
                accept="image/jpg,image/png,image/jpeg"
                typeTip="请上传格式为png、jpg或jpeg的图片"
                :crop="true"
                @uploadSuccess="thumbnailUploadSuccess"
                @uploadError="uploadError"
                @updateState="updateState"
              >
                <img v-if="ruleForm.thumbnail" :src="ruleForm.thumbnail" class="video-setting-thumbnail-img" />
                <img v-else class="video-setting-thumbnail-img video-setting-thumbnail-position" src="@imgs/share.png" />
                <div class="video-setting-thumbnail-tip video-setting-thumbnail-position">上传链接封面</div>
              </MediaUpload>
            </div>
          </el-form-item>
          <el-form-item label="视频结束后内容">
            <el-radio v-model="ruleForm.overContent" label="1">图片</el-radio>
            <el-radio v-model="ruleForm.overContent" label="0">链接</el-radio>
            <div class="video-setting-picture" v-if="ruleForm.overContent === '1'">
              <MediaUpload
                class="video-setting-picture-button video-setting-picture-common"
                accept="image/jpg,image/png,image/jpeg"
                typeTip="请上传格式为png、jpg或jpeg的图片"
                @uploadSuccess="pictureUploadSuccess"
                @uploadError="uploadError"
                @updateState="updateState"
              >
                <el-button size="small" type="primary" class="media-upload-img">上传图片</el-button>
              </MediaUpload>
              <span class="video-setting-picture-common">{{ ruleForm.overPicName }}</span>
            </div>
            <el-form-item v-else prop="overLink" class="setting-link">
              <el-input v-model="ruleForm.overLink" placeholder="请输入链接地址"></el-input>
            </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeHandler" size="small">取 消</el-button>
        <el-button type="primary" @click="clickConfirm" size="small" :disabled="saveDisabled">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MediaUpload from '@components/common/MediaUpload.vue'
import { editVideo, getVideoInfo } from '@api/video.js'

export default {
  data() {
    const checkLink = (rule, value, callback) => {
      const pattern = /[\u4E00-\u9FA5]|<|>/g
      if (pattern.test(value)) {
        callback(new Error('请输入正确内容'))
      } else {
        callback()
      }
    }
    return {
      tcVod: null,
      saveDisabled: false,
      settingDescription: '',
      cropImgUrl: '',
      ruleForm: {
        id: -1,
        shareTitle: '',
        description: '',
        thumbnail: '',
        overContent: '0',
        overLink: '',
        overPic: '',
        overPicName: '',
        overPicSize: 0
      },
      rules: {
        shareTitle: [{ required: true, message: '请输入标题名称', trigger: 'none' }],
        overLink: [{ validator: checkLink, trigger: 'none' }]
      }
    }
  },
  props: ['id', 'settingVisible'],
  computed: {
    visible: {
      get() {
        return this.settingVisible
      },
      set(val) {}
    }
  },
  methods: {
    clickConfirm() {
      this.$store.dispatch('common/login')
      this.$refs.ruleForm.validate((valid, rules) => {
        if (valid) {
          this.ruleForm.overContent = parseInt(this.ruleForm.overContent)
          editVideo(this.ruleForm).then((res) => {
            if (res.status === 200 && res.data.code === 0) {
              this.$alert('保存成功', '提示', {
                confirmButtonText: '确定'
              })
              this.$emit('settingSuccess')
              this.$emit('updateVisible', false)
            } else {
              this.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              })
            }
          })
        } else {
          if (rules.overLink) {
            this.ruleForm.overLink = ''
          }
          return false
        }
      })
    },
    closeHandler() {
      this.$emit('updateVisible', false)
    },
    thumbnailUploadSuccess(res) {
      this.ruleForm.thumbnail = res.mediaUrl
    },
    pictureUploadSuccess(res) {
      this.ruleForm.overPic = res.mediaUrl
      this.ruleForm.overPicName = res.title
      this.ruleForm.overPicSize = res.size
    },
    uploadError(err) {
      this.$alert(err, '提示', {
        confirmButtonText: '确定'
      })
    },
    updateState(state) {
      if (state === 'uploading') {
        this.saveDisabled = true
      } else {
        this.saveDisabled = false
      }
    },
    getVideoInfo(id) {
      getVideoInfo({
        id: id || ''
      })
        .then(({ data, status }) => {
          if (status === 200 && data.code === 0) {
            const { id, shareTitle, description, thumbnail, overContent, overLink, overPic, overPicName, overPicSize } = data.data
            this.ruleForm = {
              id: id,
              shareTitle: shareTitle,
              description: description || '',
              thumbnail: thumbnail || '',
              overContent: typeof overContent === 'undefined' ? '0' : String(overContent),
              overLink: overLink || '',
              overPic: overPic || '',
              overPicName: overPicName || '',
              overPicSize: overPicSize || 0
            }
          }
        })
        .catch((err) => {
          this.$alert(err, '提示', {
            confirmButtonText: '确定'
          })
        })
    }
  },
  mounted() {
    this.getVideoInfo(this.id)
  },
  components: {
    MediaUpload
  }
}
</script>

<style lang="scss" scoped>
.video-setting-wrapper {
  /deep/ .el-dialog .el-dialog__body {
    padding: 25px 70px 30px;
  }
  .video-setting-content-wrapper {
    /deep/ .video-setting-content {
      .el-form-item {
        .el-form-item__content {
          text-align: left;
          line-height: 32px;
        }
        .el-form-item__label {
          width: 120px !important;
          line-height: 32px;
        }
        .el-form-item__content {
          margin-left: 120px !important;
        }
        .el-input {
          height: 32px;
          .el-input__inner {
            height: 100%;
            padding: 4px;
          }
        }
        .el-textarea {
          height: 74px;
          .el-textarea__inner {
            font-size: 14px;
            padding: 4px;
            height: 74px;
          }
        }
        .el-radio {
          margin-bottom: 14px;
        }
        .video-end-setting-upload {
          .el-upload {
            display: inline-flex;
            height: 32px;
            align-items: center;
            justify-content: flex-start;
            .el-button {
              margin-right: 15px;
            }
          }
        }
        .video-setting-thumbnail {
          width: 116px;
          height: 116px;
          position: relative;
          .video-setting-thumbnail-tip {
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            background-color: #df5813;
            color: #ffffff;
            width: 100%;
            text-align: center;
          }
          .video-setting-thumbnail-img {
            height: 100%;
            width: 100%;
          }
          .video-setting-thumbnail-position {
            position: absolute;
            bottom: 0;
          }
        }
        .video-setting-picture {
          height: 32px;
          .video-setting-picture-button {
            width: 80px;
            margin-right: 15px;
          }
          .video-setting-picture-common {
            display: inline-block;
            vertical-align: bottom;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 80px;
          }
        }
        &.setting-link {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
}
</style>
